import { render, staticRenderFns } from "./templatedIframe.vue?vue&type=template&id=5e8f2462&"
import script from "./templatedIframe.vue?vue&type=script&lang=js&"
export * from "./templatedIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports